import hooks from './shipment-dispatches.hooks';
import createSchema from './shipment-dispatches.schema';

export default (app) => {
  const service = app.service('api/shipment-dispatches');
  service.schema = createSchema(app);
  service.hooks(hooks);
};
